import { ref } from 'vue';
import type { FeatureEvent } from '@/interface/enum';
import Api from '@/libraries/api';

const completedEvents = ref<FeatureEvent[]>([]);
const markingEvents = new Set<FeatureEvent>();

export const isFeatureEventsLoaded = ref(false);

let isFetchStarted = false;

export async function fetchFeatureEvents() {
    if (isFetchStarted) {
        return;
    }

    isFetchStarted = true;
    try {
        completedEvents.value = await Api.getFeatureEvents();
        isFeatureEventsLoaded.value = true;
    } catch (error) {
        console.error('Failed to fetch the feature events', error);
    }
}

export function isFeatureEventCompleted(event: FeatureEvent) {
    return completedEvents.value.includes(event);
}

export async function completeFeatureEvent(event: FeatureEvent) {
    if (markingEvents.has(event)) {
        return;
    }

    markingEvents.add(event);
    try {
        await Api.setFeatureEvent(event);
    } catch (error) {
        console.error('Failed to record the feature event as completed', error);
    } finally {
        completedEvents.value = [...completedEvents.value, event];
        markingEvents.delete(event);
    }
}
